;(function () {
  if (window.__NEW_CUSTOM_COLLECTION_AJAX_INIT__) return
  window.__NEW_CUSTOM_COLLECTION_AJAX_INIT__ = true

  const ROOT = '.new-custom-collection'
  const SERIES = '.new-custom-collection-series'
  const SORTING = '.collection-sorting'
  const COLLECTION_SECTION =
    '#CollectionSection[data-section-type="collection-template"]'
  const GRID = '.grid-uniform, .grid.grid-collage'
  const PAGINATION = '.pagination'
  const VIEW_MORE_BTN = '.pagination-view-more__btn'

  // 记录“当前集合状态的 URL”（用于构建 sort_by 等），但不改地址栏
  let currentUrl = window.location.href

  // 全局忙碌态（loading 遮罩）
  let busyCount = 0
  let seriesSwiper = null
  let targetCollectionSectionId = ''
  let preloadRequestId = 0

  function getUrlFromEl(el) {
    if (!el) return ''
    return (
      el.getAttribute('data-url') ||
      el.dataset?.url ||
      el.getAttribute('href') ||
      el.dataset?.href ||
      ''
    )
  }

  function getRootEl() {
    return document.querySelector(ROOT)
  }

  function getCollectionSection(scope = document) {
    const root = scope.querySelector(ROOT)
    const selectorById = targetCollectionSectionId
      ? `${COLLECTION_SECTION}[data-section-id="${targetCollectionSectionId}"]`
      : ''

    if (root && selectorById) {
      const byIdInRoot = root.querySelector(selectorById)
      if (byIdInRoot) return byIdInRoot
    }

    if (root) {
      const sectionInRoot = root.querySelector(COLLECTION_SECTION)
      if (sectionInRoot) return sectionInRoot
    }

    if (selectorById) {
      const byId = scope.querySelector(selectorById)
      if (byId) return byId
    }

    return scope.querySelector(COLLECTION_SECTION)
  }

  function ensureTargetCollectionSectionId() {
    if (targetCollectionSectionId) return targetCollectionSectionId

    const root = document.querySelector(ROOT)
    if (!root) return ''

    const candidates = root.querySelectorAll(COLLECTION_SECTION)
    if (!candidates.length) return ''

    let picked = null
    candidates.forEach((section) => {
      if (picked) return
      if (
        section.querySelector('.collection-sorting') ||
        section.querySelector('.collection-bar-box')
      ) {
        picked = section
      }
    })

    const target = picked || candidates[0]
    targetCollectionSectionId = target?.getAttribute('data-section-id') || ''
    return targetCollectionSectionId
  }

  function getGridEl(scope = document) {
    return getCollectionSection(scope)?.querySelector(GRID) || null
  }

  function getPaginationEl(scope = document) {
    return getCollectionSection(scope)?.querySelector(PAGINATION) || null
  }

  function getProductItems(scope = document) {
    const grid = getGridEl(scope)
    if (!grid) return []
    return Array.from(grid.querySelectorAll(':scope > .grid__item'))
  }

  function getViewMoreButton(scope = document) {
    return getPaginationEl(scope)?.querySelector(VIEW_MORE_BTN) || null
  }

  function getPaginationWrap(scope = document) {
    return (
      getPaginationEl(scope)?.querySelector('.pagination-view-more') || null
    )
  }

  function getPaginationProgress(scope = document) {
    return getPaginationEl(scope)?.querySelector('.pagination-progress') || null
  }

  function ensureLoadingEl(root) {
    if (!root) return null
    let el = root.querySelector('.new-custom-collection__loading')
    if (el) return el

    el = document.createElement('div')
    el.className = 'new-custom-collection__loading'
    el.setAttribute('aria-hidden', 'true')
    el.innerHTML =
      '<span class="new-custom-collection__loading-spinner"></span>'
    root.appendChild(el)
    return el
  }

  function setPageBusy(isBusy) {
    const root = getRootEl()
    if (!root) return
    ensureLoadingEl(root)

    if (isBusy) busyCount += 1
    else busyCount = Math.max(0, busyCount - 1)

    const on = busyCount > 0
    root.classList.toggle('is-loading', on)
    root.setAttribute('aria-busy', on ? 'true' : 'false')
  }

  function initSeriesSwiper() {
    const el = document.querySelector('.new-custom-collection-series.swiper')
    if (!el) return
    if (typeof window.Swiper !== 'function') return

    // 如果 Swiper 已经挂在新元素上，直接复用
    if (el.swiper) {
      seriesSwiper = el.swiper
    } else {
      // 清理旧实例（防止替换 DOM 后残留）
      if (seriesSwiper && typeof seriesSwiper.destroy === 'function') {
        try {
          seriesSwiper.destroy(true, true)
        } catch {}
      }

      seriesSwiper = new window.Swiper(el, {
        loop: false,
        slidesPerView: 6,
        spaceBetween: 16,
        breakpoints: {
          750: {
            slidesPerView: 2.2,
            spaceBetween: 16,
          },
          1000: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
          1550: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
        },
      })
    }

    // 让 active 项尽量可见
    try {
      const activeBtn = el.querySelector(
        '.new-custom-collection-series-item-link.is-active'
      )
      const slide = activeBtn?.closest('.swiper-slide')
      if (slide && seriesSwiper && typeof seriesSwiper.slideTo === 'function') {
        const slides = Array.from(el.querySelectorAll('.swiper-slide'))
        const idx = slides.indexOf(slide)
        if (idx >= 0) seriesSwiper.slideTo(idx)
      }
    } catch {}
  }

  function recalcProductMetaHeights() {
    const section = getCollectionSection(document)
    if (!section) return
    const boxes = section.querySelectorAll('.CollectionSection-inner .top-box')
    if (!boxes.length) return

    boxes.forEach((b) => {
      b.style.minHeight = '60px'
    })

    let max = 0
    boxes.forEach((b) => {
      const h = b.getBoundingClientRect().height
      if (h > max) max = h
    })

    if (max > 0) {
      boxes.forEach((b) => {
        b.style.minHeight = `${max}px`
      })
    }
  }

  function isSameOrigin(url) {
    try {
      return (
        new URL(url, window.location.href).origin === window.location.origin
      )
    } catch {
      return false
    }
  }

  function isCollectionLikeUrl(url) {
    try {
      const u = new URL(url, window.location.href)
      // 只拦截站内 collection 页面相关跳转（含 tag 路径、sort_by、page 等）
      return u.pathname.includes('/collections/')
    } catch {
      return false
    }
  }

  function buildCollectionRequestUrl(targetUrl) {
    try {
      const target = new URL(targetUrl, window.location.href)
      const current = new URL(currentUrl || window.location.href)
      const keepKeys = ['view', 'preview_theme_id', '_ab', '_fd', 'pb']

      keepKeys.forEach((key) => {
        if (!target.searchParams.has(key) && current.searchParams.has(key)) {
          target.searchParams.set(key, current.searchParams.get(key) || '')
        }
      })

      return target.toString()
    } catch {
      return targetUrl
    }
  }

  function setSeriesActiveButton(activeBtn) {
    const seriesRoot = document.querySelector(SERIES)
    if (!seriesRoot || !activeBtn) return

    const all = seriesRoot.querySelectorAll(
      '.new-custom-collection-series-item-link'
    )
    all.forEach((btn) => {
      btn.classList.remove('is-active')
      btn.setAttribute('aria-pressed', 'false')
    })

    activeBtn.classList.add('is-active')
    activeBtn.setAttribute('aria-pressed', 'true')
  }

  function syncSeriesActiveByUrl(url) {
    const seriesRoot = document.querySelector(SERIES)
    if (!seriesRoot) return

    let target
    try {
      target = new URL(url, window.location.href)
    } catch {
      return
    }

    const all = seriesRoot.querySelectorAll(
      '.new-custom-collection-series-item-link[data-url]'
    )
    let matchedBtn = null

    all.forEach((btn) => {
      const btnUrl = getUrlFromEl(btn)
      if (!btnUrl) return

      try {
        const parsed = new URL(btnUrl, window.location.href)
        if (parsed.pathname === target.pathname && !matchedBtn) {
          matchedBtn = btn
        }
      } catch {}
    })

    if (matchedBtn) setSeriesActiveButton(matchedBtn)
  }

  function setLoading(el, loading) {
    if (!el) return
    el.classList.toggle('is-loading', !!loading)
    if (loading) el.setAttribute('aria-busy', 'true')
    else el.removeAttribute('aria-busy')
  }

  function setDisabled(el, disabled) {
    if (!el) return
    el.classList.toggle('is-disabled', !!disabled)
    el.setAttribute('aria-disabled', disabled ? 'true' : 'false')

    if (el.tagName === 'BUTTON') {
      el.disabled = !!disabled
    } else if (el.tagName === 'A') {
      if (disabled) {
        el.dataset.href = el.getAttribute('href') || ''
        el.removeAttribute('href')
        el.setAttribute('tabindex', '-1')
      } else {
        const href = el.getAttribute('href') || el.dataset.href
        if (href) el.setAttribute('href', href)
        el.removeAttribute('tabindex')
      }
    }
  }

  function setItemHidden(item, hidden) {
    if (!item) return
    if (hidden) {
      item.style.display = 'none'
      item.setAttribute('aria-hidden', 'true')
    } else {
      item.style.display = ''
      item.removeAttribute('aria-hidden')
    }
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html')
  }

  function normalizeUrl(url) {
    try {
      return new URL(url, window.location.href).toString()
    } catch {
      return ''
    }
  }

  function getNextPageUrl(scope = document) {
    const pagination = getPaginationEl(scope)
    if (!pagination) return ''

    return (
      pagination.querySelector('.pagination-view-more')?.dataset?.nextUrl ||
      getUrlFromEl(pagination.querySelector(VIEW_MORE_BTN)) ||
      pagination.querySelector('a[rel="next"]')?.getAttribute('href') ||
      ''
    )
  }

  function updateProgress(visibleCount, totalCount) {
    const progress = getPaginationProgress(document)
    if (!progress) return

    const fill = progress.querySelector('.pagination-progress__fill')
    const safeTotal = Math.max(1, Number(totalCount) || 0)
    const safeVisible = Math.max(
      0,
      Math.min(Number(visibleCount) || 0, safeTotal)
    )
    const pct = Math.min(100, Math.max(0, (safeVisible / safeTotal) * 100))

    progress.setAttribute('aria-valuemin', '0')
    progress.setAttribute('aria-valuemax', String(safeTotal))
    progress.setAttribute('aria-valuenow', String(safeVisible))

    if (fill) {
      fill.style.width = `${pct}%`
      fill.style.transform = 'none'
    }
  }

  function updateViewMoreUI({
    pageSize,
    visibleCount,
    totalCount,
    nextUrl = '',
  }) {
    const btn = getViewMoreButton(document)
    const wrap = getPaginationWrap(document)
    if (!btn || !wrap) return

    const safePageSize = Math.max(1, Number(pageSize) || 1)
    const safeTotal = Math.max(0, Number(totalCount) || 0)
    const safeVisible = Math.max(
      0,
      Math.min(Number(visibleCount) || 0, safeTotal)
    )

    wrap.dataset.pageSize = String(safePageSize)
    wrap.dataset.visibleCount = String(safeVisible)
    wrap.dataset.totalCount = String(safeTotal)
    wrap.dataset.nextUrl = nextUrl || ''

    if (safeVisible >= safeTotal) {
      btn.removeAttribute('data-url')
      setDisabled(btn, true)
    } else {
      if (nextUrl) btn.setAttribute('data-url', nextUrl)
      setDisabled(btn, false)
    }

    updateProgress(safeVisible, safeTotal)
  }

  function setupLocalViewMore({ pageSize }) {
    const items = getProductItems(document)
    const totalCount = items.length
    if (!totalCount) return

    const safePageSize = Math.max(1, Number(pageSize) || 1)
    const visibleCount = Math.min(safePageSize, totalCount)

    items.forEach((item, index) => {
      setItemHidden(item, index >= visibleCount)
    })

    updateViewMoreUI({
      pageSize: safePageSize,
      visibleCount,
      totalCount,
      nextUrl: '',
    })

    lazySizesRecheck()
    dispatchUpdated()
  }

  function revealNextChunk(btn) {
    const wrap =
      btn?.closest('.pagination-view-more') || getPaginationWrap(document)
    if (!wrap) return

    const items = getProductItems(document)
    const totalCount = items.length
    if (!totalCount) {
      updateViewMoreUI({
        pageSize: 1,
        visibleCount: 0,
        totalCount: 0,
        nextUrl: '',
      })
      return
    }

    const pageSize = Math.max(
      1,
      Number(wrap.dataset.pageSize) ||
        Number(
          getCollectionSection(document)?.getAttribute('data-page-size')
        ) ||
        1
    )
    const visibleCount = Math.max(0, Number(wrap.dataset.visibleCount) || 0)
    const nextVisibleCount = Math.min(totalCount, visibleCount + pageSize)

    for (let i = visibleCount; i < nextVisibleCount; i += 1) {
      setItemHidden(items[i], false)
    }

    updateViewMoreUI({
      pageSize,
      visibleCount: nextVisibleCount,
      totalCount,
      nextUrl: '',
    })

    lazySizesRecheck()
    dispatchUpdated()
  }

  function lazySizesRecheck() {
    if (window.lazySizes?.autoSizer?.checkElems)
      window.lazySizes.autoSizer.checkElems()
  }

  function dispatchUpdated() {
    document.dispatchEvent(new CustomEvent('newCustomCollection:updated'))
  }

  function replaceProductsAndPaginationFromDoc(doc) {
    const nextSection = getCollectionSection(doc)
    const curSection = getCollectionSection(document)
    if (!nextSection || !curSection) return false

    const nextGrid = nextSection.querySelector(GRID)
    const curGrid = curSection.querySelector(GRID)
    if (!nextGrid || !curGrid) return false

    curGrid.replaceWith(nextGrid)
    const liveGrid = curSection.querySelector(GRID) || nextGrid

    const nextPagination = nextSection.querySelector(PAGINATION)
    const curPagination = curSection.querySelector(PAGINATION)
    if (nextPagination && curPagination) {
      curPagination.replaceWith(nextPagination)
    } else if (nextPagination && !curPagination) {
      liveGrid.insertAdjacentElement('afterend', nextPagination)
    } else if (!nextPagination && curPagination) {
      curPagination.remove()
    }

    return true
  }

  async function preloadAllProductsForCurrentState(url) {
    const currentRequestId = ++preloadRequestId
    const currentGrid = getGridEl(document)
    if (!currentGrid) return

    const initialItems = getProductItems(document)
    const pageSize = Math.max(1, initialItems.length || 1)

    let nextUrl = getNextPageUrl(document)
    const visited = new Set()
    const btn = getViewMoreButton(document)

    if (btn) setLoading(btn, true)

    try {
      while (nextUrl) {
        if (currentRequestId !== preloadRequestId) return

        const requestUrl = buildCollectionRequestUrl(nextUrl)
        const normalized = normalizeUrl(requestUrl)
        if (!normalized || visited.has(normalized)) break
        visited.add(normalized)

        const res = await fetch(requestUrl, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })
        if (!res.ok) throw new Error('HTTP ' + res.status)

        const html = await res.text()
        const doc = parseHTML(html)
        const incomingGrid = getGridEl(doc)
        if (!incomingGrid) break

        const newItems = incomingGrid.querySelectorAll(':scope > .grid__item')
        if (!newItems.length) break
        const fragment = document.createDocumentFragment()
        newItems.forEach((n) => {
          setItemHidden(n, true)
          fragment.appendChild(n)
        })
        currentGrid.appendChild(fragment)

        nextUrl = getNextPageUrl(doc)
      }

      setupLocalViewMore({ pageSize })

      if (url) currentUrl = url
    } finally {
      if (btn) setLoading(btn, false)
    }
  }

  function replacePagePartsFromDoc(doc) {
    const curRoot = document.querySelector(ROOT) || document
    ensureTargetCollectionSectionId()

    // 1) 替换系列筛选条（确保 is-active 等状态同步）
    const nextSeries = doc.querySelector(SERIES)
    const curSeries = document.querySelector(SERIES)
    if (nextSeries && curSeries) {
      // 替换前销毁旧 Swiper
      try {
        curSeries.swiper?.destroy(true, true)
      } catch {}
      curSeries.replaceWith(nextSeries)
    }

    // 2) 替换排序条（确保 select 当前值同步）
    const nextSection = getCollectionSection(doc)
    const curSection = getCollectionSection(document)
    const nextSorting = nextSection?.querySelector(SORTING)
    const curSorting = curSection?.querySelector(SORTING)
    if (nextSorting && curSorting) curSorting.replaceWith(nextSorting)

    // 3) 仅替换产品列表和分页，避免整块替换导致排序区丢失
    const replaced = replaceProductsAndPaginationFromDoc(doc)

    // 兜底：若局部替换失败再整块替换
    if (!replaced && nextSection && curSection)
      curSection.replaceWith(nextSection)

    lazySizesRecheck()
    dispatchUpdated()
    return curRoot
  }

  async function fetchAndReplace(
    url,
    { pushState = false, scrollToSection = true } = {}
  ) {
    setPageBusy(true)
    try {
      const res = await fetch(url, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
      if (!res.ok) throw new Error('HTTP ' + res.status)

      const html = await res.text()
      const doc = parseHTML(html)

      replacePagePartsFromDoc(doc)
      syncSeriesActiveByUrl(url)
      initSeriesSwiper()
      await preloadAllProductsForCurrentState(url)

      // 不跳转/不改地址栏，但内部状态需要跟随最新请求
      currentUrl = url

      if (pushState) history.pushState({ url }, '', url)

      if (scrollToSection) {
        const section = getCollectionSection(document)
        if (section)
          section.scrollIntoView({ block: 'start', behavior: 'smooth' })
      }
    } finally {
      setPageBusy(false)
    }
  }

  function buildUrlWithSortBy(sortBy) {
    const u = new URL(currentUrl, window.location.href)
    if (!sortBy) u.searchParams.delete('sort_by')
    else u.searchParams.set('sort_by', sortBy)
    return u.toString()
  }

  // 事件：排序 select（不刷新）
  document.addEventListener('change', (e) => {
    const root = e.target.closest(ROOT)
    if (!root) return

    if (e.target.matches('.filter-dropdown__select')) {
      const url = buildUrlWithSortBy(e.target.value)
      fetchAndReplace(url, { pushState: false }).catch((err) =>
        console.error('[new-custom-collection ajax] sort failed', err)
      )
    }
  })

  // 事件：点击（tag 链接 / 分页 / View More）
  document.addEventListener('click', (e) => {
    const root = e.target.closest(ROOT)
    if (!root) return

    // A) 全端 View More：仅显示已预取数据，不发请求
    const vm = e.target.closest(VIEW_MORE_BTN)
    if (vm) {
      const disabled =
        vm.classList.contains('is-disabled') ||
        vm.getAttribute('aria-disabled') === 'true'

      if (disabled) {
        e.preventDefault()
        return
      }

      // 阻止 <a> 跳转（兼容旧结构）
      if (vm.tagName === 'A') e.preventDefault()
      if (vm.classList.contains('is-loading')) return

      setLoading(vm, true)
      try {
        revealNextChunk(vm)
      } catch (err) {
        console.error('[new-custom-collection ajax] view more failed', err)
      } finally {
        setLoading(vm, false)
      }

      return
    }

    // B) 其它 collection 内链接：仅保留 series 的异步切换
    const btn = e.target.closest('button[data-url]')
    if (btn) {
      const rawUrl = getUrlFromEl(btn)
      if (!rawUrl || !isSameOrigin(rawUrl) || !isCollectionLikeUrl(rawUrl))
        return

      const url = buildCollectionRequestUrl(rawUrl)

      const inSeries = !!btn.closest(SERIES)
      if (!inSeries) return

      if (inSeries) setSeriesActiveButton(btn)

      fetchAndReplace(url, { pushState: false }).catch((err) =>
        console.error('[new-custom-collection ajax] navigate failed', err)
      )
      return
    }

    // 兼容旧结构：如果仍然存在 a[href]，继续拦截
    const a = e.target.closest('a[href]')
    if (!a) return
    if (a.target === '_blank' || a.hasAttribute('download')) return

    const href = a.getAttribute('href')
    if (!href || href.startsWith('#')) return
    if (!isSameOrigin(href)) return
    if (!isCollectionLikeUrl(href)) return

    const inSeries = !!a.closest(SERIES)
    if (!inSeries) return

    e.preventDefault()
    const url = buildCollectionRequestUrl(a.href)
    if (inSeries) setSeriesActiveButton(a)
    fetchAndReplace(url, { pushState: false }).catch((err) =>
      console.error('[new-custom-collection ajax] navigate failed', err)
    )
  })

  // 每次局部更新后：重启 Swiper、重新计算产品卡片高度
  document.addEventListener('newCustomCollection:updated', () => {
    initSeriesSwiper()
    recalcProductMetaHeights()
  })

  // 首屏初始化
  ensureTargetCollectionSectionId()
  initSeriesSwiper()
  recalcProductMetaHeights()
  preloadAllProductsForCurrentState(currentUrl).catch((err) =>
    console.error('[new-custom-collection ajax] preload failed', err)
  )

  // 后退/前进：拉取对应 URL 并替换（不 pushState）
  window.addEventListener('popstate', () => {
    if (!document.querySelector(ROOT)) return
    if (!isCollectionLikeUrl(window.location.href)) return
    fetchAndReplace(window.location.href, {
      pushState: false,
      scrollToSection: false,
    }).catch((err) =>
      console.error('[new-custom-collection ajax] popstate failed', err)
    )
  })
})()
